'use client';
import { useLayoutEffect } from 'react';
/** Applies a staged guided pose in the same commit as the frame's geometry, so tracked items cannot lag the camera. */
export function CameraFrameCommit(props) {
    const { controller, frame } = props;
    useLayoutEffect(() => {
        controller?.commitFrame?.(frame);
    }, [controller, frame]);
    return null;
}
